import React from 'react'
import { useLocation } from 'react-router-dom'
import { WhatsappLink, WhatsappIcon } from './WhatsappButtonStyles'
import { buildWhatsappUrl, whatsappMessageForPath } from '../../data/contact'

export default function WhatsappButton({ message }) {
  const location = useLocation()
  const finalMessage = message || whatsappMessageForPath(location.pathname)

  // En productos ya está el botón flotante "Consultar más info" (que abre WhatsApp)
  if (location.pathname.startsWith('/productos')) return null

  return (
    <WhatsappLink
      href={buildWhatsappUrl(finalMessage)}
      target='_blank'
      rel="noreferrer"
      aria-label="Contactar por WhatsApp"
    >
        <WhatsappIcon className="fa fa-whatsapp"></WhatsappIcon>
    </WhatsappLink>
  )
}
